import { render, staticRenderFns } from "./labelDialog.vue?vue&type=template&id=0919ebe8&scoped=true&"
import script from "./labelDialog.vue?vue&type=script&lang=js&"
export * from "./labelDialog.vue?vue&type=script&lang=js&"
import style0 from "./labelDialog.vue?vue&type=style&index=0&id=0919ebe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0919ebe8",
  null
  
)

export default component.exports